module.exports = __webpack_public_path__ + "images/sweeper.769b176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hoverProducts/sweeper.png
// module id = 41v5
// module chunks = 19